import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';
import { Icon } from '@app/src/common/Icon';
import { FieldForm } from '@app/src/common/FieldForm';
import { fetchTypeOperationAction } from '@app/src/views/StepOne/form';
import { TypeOperationRadioInputShimmer } from './TypeOperationRadioInputShimmer';

import {
  RadioInputWrapper,
  Option,
  Title,
  Description,
  IconWrapper
} from './styled';

interface Props {
  colorTheme: string;
}

export const TypeOperationRadioInput: React.FC<Props> = ({ colorTheme }) => {
  const dispatch = useDispatch();
  const operations = useSelector(state => state.typeOperation.data);
  const category = useSelector(state => state.print.general.category);
  const currentOperation = useSelector(state => state.form.stepOne.values.operation);
  const printOperation = useSelector(state => state.print.general.operation);
  const printOperationName = useSelector(state => state.print.general.operationName);

  useEffect(() => {
    if (category) {
      dispatch(fetchTypeOperationAction(category));
      dispatch(change('stepOne', 'category', category));
    }
  }, [category]);

  useEffect(() => {
    if (operations && operations.length > 0) {
      if (printOperation) {
        dispatch(change('stepOne', 'operation', printOperation));
        dispatch(change('stepOne', 'operationName', printOperationName));
      }
    }
  }, [operations]);

  const handleChange = (value: string, text: string) => {
    dispatch(change('stepOne', 'operation', Number(value)));
    dispatch(change('stepOne', 'operationName', text));
  };

return (
  <React.Fragment>
    <FieldForm label="Seleccione un tipo de aviso">
      { operations && operations.length > 0 ?
          operations.map((item, index) => (
            <RadioInputWrapper
              key={index}
              name="typeOperation"
              value={item.data.id}
              colorActive={colorTheme}
              handleChange={value => handleChange(value, item.data.name)}
              checked={item.data.id === currentOperation}
            >
              { item.data.icon && <IconWrapper>
                <Icon data-name={item.data.icon} fill={colorTheme} width="24" height="24" />
              </IconWrapper> }
              <Option>
                <Title>{item.data.name}</Title>
                <Description>{item.data.description}</Description>
              </Option>
            </RadioInputWrapper>
          ))
        :
          <TypeOperationRadioInputShimmer />
      }
    </FieldForm>
  </React.Fragment>
)};